import { render, staticRenderFns } from "./GoodsForm3.vue?vue&type=template&id=35590a2f&scoped=true&"
import script from "./GoodsForm3.vue?vue&type=script&lang=js&"
export * from "./GoodsForm3.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm3.vue?vue&type=style&index=0&id=35590a2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35590a2f",
  null
  
)

export default component.exports